import { Component, Input, OnInit } from '@angular/core';
import { map } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavaidModel, NavAidsCsvModel } from 'src/app/models/navaid';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { HttpClient } from '@angular/common/http';
import * as fileSaver from 'file-saver';
import { NavaidsService } from 'src/app/services/navaids.service';

@Component({
  selector: 'app-duplicate-navaids',
  templateUrl: './duplication-check.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class DuplicationCheckComponent implements OnInit {

  @Input()
  duplicates:NavaidModel[]

  constructor(public bsModalRef: BsModalService,
  public pointsService: PointsService,
  private endpointService: EndpointsService,
  private http: HttpClient,
  private modalControlService: ModalControlService,
  private navaidsService: NavaidsService
  ) { }


public static showDuplicates(navaids: NavaidModel[],modalService:BsModalService, modalControl:ModalControlService){
  let duplicates: NavaidModel[] = [];
  const processedIds = new Set<string>();

  for (let i = 0; i < navaids.length-1; i++) {
      if (processedIds.has(navaids[i].id)) {
          continue;
      }

      processedIds.add(navaids[i].id);
      let duplicateDetected = false;

      for (let j = i + 1; j < navaids.length; j++) {
          if (NavaidModel.duplicationCheckDesktopCondition(navaids[i], navaids[j])) {
              duplicates.push(navaids[j]);
              processedIds.add(navaids[j].id);
              duplicateDetected = true;
          }
      }

      if (duplicateDetected) {
          duplicates.push(navaids[i]);
      }
  }
  if(duplicates.length>0){
    let bsRef: BsModalRef = modalService.show(DuplicationCheckComponent);
    bsRef.content.duplicates = duplicates.sort((navaid1,navaid2)=> navaid1.navaidid > navaid2.navaidid? 1 : -1 );
    return;
  }
  modalControl.showMesssageModal("Duplicate Check Done", "No duplicates were found.","Ok");
}
  ngOnInit(): void {
  }

  exportNavaidsToCsv(){
    let navaidsPayload: NavaidModel[] = [];
    this.duplicates.forEach((navaid) => navaidsPayload.push(this.navaidsService.getNavaidPayload(navaid)));
    this.http.post(this.endpointService.endpointDownloadCSVNavaids,
      navaidsPayload,
      this.endpointService.fileHttpOptions
      ).subscribe(
        (blob:Blob) => {
          fileSaver.saveAs(blob, "navaidFile.csv");
        },
        (error) => this.modalControlService.showMesssageModal("error","Error generating csv file")
      )
  }

}
